// Logo tek yerden yönetilir. Yeni görsel logo hazır olduğunda LOGO_SRC'yi doldurun;
// dolu olduğunda otomatik olarak görsel logo kullanılır, boşsa yazı logosu gösterilir.
export const LOGO_SRC = "/assets/voyacar-logo.webp";

export const Logo = ({ className = "h-10", onDark = false }) => {
  if (LOGO_SRC) {
    return (
      <img src={LOGO_SRC} alt="VoyaCar Rental" className={`${className} w-auto object-contain`} data-testid="voyacar-logo" />
    );
  }
  return (
    <div className={`flex flex-col leading-none ${className} justify-center`} data-testid="voyacar-logo">
      <span className="font-heading font-extrabold text-xl sm:text-2xl text-white">VoyaCar</span>
      <span className="text-[10px] sm:text-xs font-medium tracking-[0.35em] text-white/85">RENTAL</span>
    </div>
  );
};

export default Logo;
